import { render, staticRenderFns } from "./PaqueteBusquedaIndividual.vue?vue&type=template&id=7b2c323c&scoped=true"
import script from "./PaqueteBusquedaIndividual.vue?vue&type=script&lang=js"
export * from "./PaqueteBusquedaIndividual.vue?vue&type=script&lang=js"
import style0 from "./PaqueteBusquedaIndividual.vue?vue&type=style&index=0&id=7b2c323c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2c323c",
  null
  
)

export default component.exports